import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=05618148&"
import script from "./Mfa.vue?vue&type=script&lang=ts&"
export * from "./Mfa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports